import * as React from 'react';
import * as autoBind from 'react-autobind';
import ValuePropModal from '../ValuePropModal/ValuePropModal';
import TrialModalGraphic from '../../assets/trial-graphic.svg';
import UserModel from '../../types/UserModel';
import EntitlementService from '../../services/EntitlementService/EntitlementService';
import UserMessaging from '../../utils/UserMessaging';
import Constants, {ModalStates} from '../../globals/Constants';
import Strings from '../../globals/Strings';
import HotjarService from '../../services/HotjarService/HotjarService';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';

export default class TrialModal extends React.Component<TrialModalProps, {}> {
   constructor(props: TrialModalProps) {
      super(props);
      autoBind(this);
   }

   startTrial() {
      const {setModalState, currentUser, startNewReview} = this.props;

      if (startNewReview) {
         setModalState(ModalStates.newReview);
      } else {
         setModalState(ModalStates.closed);
      }

      return EntitlementService.startTrialAndSave(currentUser.userId).catch(() => {
         setModalState(ModalStates.closed);
         UserMessaging.warn(Strings.errors.couldNotStartTrial);
      });
   }

   onClose() {
      HotjarService.startTrialModalClosed();
      this.props.onClose();
   }

   render() {
      return (
         <ValuePropModal bannerText={Strings.labels.trialModalBannerSubText}
                         benefitList={Strings.labels.pricing.list}
                         valuePropModalGraphic={<TrialModalGraphic/>}
                         themeName={this.props.themeName}
                         testId="trial-modal"
                         onClose={this.onClose}>
            <div className="button-group">
               <ControlButton buttonType={TscButtonType.secondary}
                              label={Strings.labels.trialModalLearnMorePrompt}
                              href={Constants.siteLinks.videoReviewSplash}
                              openLinkInNewTab={true}
                              themeName={this.props.themeName}
                              testId="trial-modal-learn-more-button" />

               <ControlButton buttonType={TscButtonType.primary}
                              label={Strings.labels.trialModalPrompt}
                              onClick={this.startTrial}
                              themeName={this.props.themeName}
                              testId="trial-modal-confirm-button" />
            </div>
         </ValuePropModal>
      );
   }
}

export interface TrialModalProps extends Themeable {
   startNewReview: boolean;
   currentUser: UserModel;
   onClose(): void;
   setModalState(modalState: ModalStates): void;
}
